import type { ReactNode } from 'react';

interface AlertProps {
  tone?: 'info' | 'success' | 'warning' | 'danger';
  title?: ReactNode;
  children?: ReactNode;
  /** Use `alert` para mensagens que exigem atenção imediata (erros). */
  role?: 'alert' | 'status' | 'note';
  className?: string;
}

export function Alert({ tone = 'info', title, children, role, className }: AlertProps) {
  const ariaRole = role ?? (tone === 'danger' ? 'alert' : 'status');
  return (
    <div className={`alert alert--${tone}${className ? ` ${className}` : ''}`} role={ariaRole}>
      {title && <p className="alert__title">{title}</p>}
      {children && <div className="alert__body">{children}</div>}
    </div>
  );
}
